import AvatarImage from "./avatar-image";

export default AvatarImage;